import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatProductValue } from './formatProductValue';
import {
  getSamplingValueSummary,
  normalizePhysicalSamplingConfig
} from './adapters';
import { SamplingMode, SamplingValueSummary } from './types';

/** displayValue must come from a confirmed API adapter; multiple prices are never summed here. */
const ProductValueLabel: React.FC<{
  product: unknown;
  displayValue?: SamplingValueSummary;
}> = ({ product, displayValue }) => {
  const { t, i18n } = useTranslation();
  displayValue = displayValue ?? getSamplingValueSummary(product);
  const locale = i18n?.resolvedLanguage || i18n?.language || 'en-US';
  const config = normalizePhysicalSamplingConfig(product);
  const multiple = config?.mode === SamplingMode.MULTIPLE_PRODUCTS;
  const price =
    displayValue?.amountUsd ??
    (!multiple ? config?.products[0]?.retailPriceUsd : undefined);
  if (price !== undefined && price !== null && Number.isFinite(price)) {
    return (
      <span>
        {displayValue?.isUpperBound
          ? t('physical_product.sampling.value_up_to', {
              defaultValue: 'Up to {{value}} in product value',
              value: formatProductValue(price, locale)
            })
          : formatProductValue(price, locale)}
      </span>
    );
  }
  return (
    <span>
      {t('physical_product.sampling.choose_from_products', {
        defaultValue: 'Choose up to {countNum} of {total} products',
        interpolation: { prefix: '{', suffix: '}' },
        countNum: config?.maxSelectableProducts ?? 1,
        total: config?.products.length ?? 1
      })}
    </span>
  );
};
export default ProductValueLabel;
